import { AtsCandidatesUpdateTalentPoolDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

interface UseUpdateTalentPool {
  candidateId: number
  currentTalentPoolValue: boolean
}

export const useUpdateTalentPool = ({
  candidateId,
  currentTalentPoolValue,
}: UseUpdateTalentPool) => {
  const [update, { loading }] = useMutation(AtsCandidatesUpdateTalentPoolDocument, {
    extractorFn: (data) => data.atsMutations.updateAtsCandidate,
  })

  const updateTalentPoolValue = async () => {
    const newTalentPoolValue = !currentTalentPoolValue

    const { success } = await asyncAction(
      () => update({ variables: { id: candidateId, talentPool: newTalentPoolValue } }),
      {
        successMessage: currentTalentPoolValue
          ? i18n.t('common.removed_successfully')
          : i18n.t('common.saved_successfully'),
      }
    )

    if (newTalentPoolValue) {
      track(trackingEvents.ats.addCandidateToTalentPool, {
        is_successful: success,
      })
    }

    return { success }
  }

  return {
    updateTalentPoolValue,
    loading,
  }
}
